import MuiBadge from '@mui/material/Badge'; // Note that this implicitly renames the import from Badge to MuiBadge to avoid naming conflicts below. The MUI component is NOT named MuiBadge.
import { type JSX, ReactNode } from 'react';

interface BadgeProps {
    amount: number;
    color: 'blue' | 'red';
    variant?: 'dot' | 'standard';
    children: ReactNode;
}

export const Badge = (props: BadgeProps): JSX.Element => {
    const color = props.color === 'blue' ? 'var(--hps-light-blue)' : 'var(--hps-red)';
    return (
        <MuiBadge badgeContent={props.amount} sx={{ '& .MuiBadge-badge': { backgroundColor: color } }} variant={props.variant}>
            {props.children}
        </MuiBadge>
    );
};
